import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const MarkerPin01Icon = (props?: SvgProps) => (
  <svg
    height="20"
    width="20"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M15.8333 8.33337C15.8333 5.11171 13.2217 2.50004 10 2.50004C6.77834 2.50004 4.16667 5.11171 4.16667 8.33337C4.16667 9.91012 4.87741 11.3986 6.07666 12.9558C7.1433 14.3408 8.52435 15.6936 10 17.1582C11.4757 15.6936 12.8567 14.3408 13.9233 12.9558C15.1226 11.3986 15.8333 9.91012 15.8333 8.33337ZM11.6667 8.33337C11.6667 7.4129 10.9205 6.66671 10 6.66671C9.07953 6.66671 8.33333 7.4129 8.33333 8.33337C8.33333 9.25385 9.07953 10 10 10C10.9205 10 11.6667 9.25385 11.6667 8.33337ZM13.3333 8.33337C13.3333 10.1743 11.8409 11.6667 10 11.6667C8.15905 11.6667 6.66667 10.1743 6.66667 8.33337C6.66667 6.49242 8.15905 5.00004 10 5.00004C11.8409 5.00004 13.3333 6.49242 13.3333 8.33337ZM17.5 8.33337C17.5 10.4385 16.544 12.2833 15.2433 13.9722C13.9508 15.6505 12.2282 17.2836 10.5892 18.9226C10.2638 19.248 9.73624 19.248 9.41081 18.9226C7.77182 17.2836 6.04922 15.6505 4.75667 13.9722C3.45597 12.2833 2.5 10.4385 2.5 8.33337C2.5 4.19124 5.85786 0.833374 10 0.833374C14.1421 0.833374 17.5 4.19124 17.5 8.33337Z"
      fill="#474A53"
    />
  </svg>
)
